var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 120 120",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A0D995;}\r\n\t.st1{fill:#6CC4A1;}\r\n\t.st2{fill:#F6E3C5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.9,77.7l-3.2,3.2c-4.9,4.9-9.8,8.1-13.8,4.1L35.1,62.1c-4.1-4.1-0.9-8.9,4.1-13.8l3.2-3.2L26.7,29.5   l-4.5,4.5c-8,8-8,20.9,0,28.8l35,35c8,8,20.9,8,28.8,0l4.5-4.5L74.9,77.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45,43.7L28.4,27.1c-1.5-1.5-4-1.5-5.5,0l-2.8,2.8c-1.5,1.5-1.5,4,0,5.5L36.7,52c1.5,1.5,4,1.5,5.5,0l2.8-2.8    C46.5,47.7,46.5,45.3,45,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.9,91.6L76.3,75c-1.5-1.5-4-1.5-5.5,0L68,77.8c-1.5,1.5-1.5,4,0,5.5l16.6,16.6c1.5,1.5,4,1.5,5.5,0    l2.8-2.8C94.4,95.6,94.4,93.2,92.9,91.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.1,46.6c-0.4-0.4-0.7-0.9-0.8-1.4c-0.4-1.6,0.6-3.1,2.2-3.5c5.6-1.3,11.3,0.4,15.3,4.4s5.7,9.8,4.4,15.3    c-0.4,1.6-1.9,2.5-3.5,2.2c-1.6-0.4-2.5-1.9-2.2-3.5c0.8-3.6-0.2-7.3-2.8-9.9c-2.6-2.6-6.3-3.7-9.9-2.8    C58.8,47.6,57.8,47.3,57.1,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.6,35.2c-0.4-0.4-0.7-0.9-0.8-1.4c-0.4-1.6,0.6-3.1,2.2-3.5c9.5-2.2,19.3,0.6,26.2,7.5    c6.9,6.9,9.7,16.6,7.5,26.2c-0.4,1.6-1.9,2.6-3.5,2.2c-1.6-0.4-2.6-1.9-2.2-3.5c1.7-7.5-0.5-15.3-5.9-20.7    c-5.4-5.4-13.2-7.7-20.7-5.9C56.3,36.2,55.3,35.9,54.6,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.1,23.8c-0.4-0.4-0.7-0.9-0.8-1.4c-0.4-1.6,0.6-3.1,2.2-3.5c13.4-3.1,27.3,0.9,37,10.6    c9.7,9.7,13.7,23.5,10.6,37c-0.4,1.6-1.9,2.6-3.5,2.2c-1.6-0.4-2.6-1.9-2.2-3.5c2.6-11.5-0.8-23.3-9-31.5    c-8.3-8.3-20.1-11.7-31.5-9C53.8,24.8,52.8,24.5,52.1,23.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.b89c5df12c29147c77b79a118799058d.svg";
export { ForwardRef as ReactComponent };